import { Link } from "react-router-dom";
import ChurchFlowLogo from "@/components/ChurchFlowLogo";

export default function Footer({ variant = "app" }) {
  return (
    <footer
      data-testid="site-footer"
      className={
        variant === "auth"
          ? "border-t border-border mt-auto"
          : "border-t border-border bg-card/40 mt-16"
      }
    >
      <div className="max-w-[1500px] mx-auto px-8 lg:px-12 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <ChurchFlowLogo size={32} className="rounded-xl" />
            <span className="font-serif text-lg tracking-tight">ChurchFlow</span>
          </div>
          <p className="text-sm text-muted-foreground mt-4 max-w-md leading-relaxed">
            Professional church financial management by{" "}
            <a
              href="https://ministrybranch.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground hover:text-primary underline-offset-4 hover:underline"
              data-testid="footer-ministrybranch-link"
            >
              Ministry Branch
            </a>
            . Built in Fresno, California for ministries everywhere.
          </p>
          <div className="text-xs text-muted-foreground mt-5">
            © {new Date().getFullYear()} Ministry Branch. All rights reserved.
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/legal/terms"
                className="text-foreground/80 hover:text-primary underline-offset-4 hover:underline"
                data-testid="footer-terms-link"
              >
                Terms of Use
              </Link>
            </li>
            <li>
              <Link
                to="/legal/privacy"
                className="text-foreground/80 hover:text-primary underline-offset-4 hover:underline"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/legal/ccpa"
                className="text-foreground/80 hover:text-primary underline-offset-4 hover:underline"
                data-testid="footer-ccpa-link"
              >
                CCPA / CPRA Rights
              </Link>
            </li>
            <li>
              <Link
                to="/legal/dnsmpi"
                className="text-foreground/80 hover:text-primary underline-offset-4 hover:underline"
                data-testid="footer-dnsmpi-link"
              >
                Do Not Sell or Share My Personal Information
              </Link>
            </li>
            <li>
              <a
                href="mailto:legal@ministrybranch.com"
                className="text-foreground/80 hover:text-primary underline-offset-4 hover:underline"
                data-testid="footer-legal-email"
              >
                legal@ministrybranch.com
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
